angular.module('cfn').directive('cfnPageRight', [
  '$rootScope',
  function($rootScope) {
    return {
      restrict: 'E',
      scope: { title: '@' },
      transclude: true,
      templateUrl: require('./cfnPageRight.html'),
      link: function(scope, element, attrs) {
        scope.$rootScope = $rootScope;
      }
    };
  }
]);
